(() => {
  if (window.Box31InServiceGalleryInitialized) return;
  window.Box31InServiceGalleryInitialized = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-inservice-open]');

    if (opener) {
      const root = opener.closest('[data-inservice-gallery]');
      const dialog = root?.querySelector('[data-inservice-dialog]');
      if (!dialog) return;

      const image = dialog.querySelector('[data-inservice-dialog-image]');
      const caption = dialog.querySelector('[data-inservice-dialog-caption]');
      const productLink = dialog.querySelector('[data-inservice-dialog-product]');

      image.src = opener.dataset.full || '';
      image.alt = opener.dataset.alt || '';
      caption.textContent = opener.dataset.caption || '';

      const productUrl = opener.dataset.productUrl || '';
      const productTitle = opener.dataset.productTitle || '';

      if (productUrl) {
        productLink.href = productUrl;
        productLink.textContent = productTitle ? `Shop ${productTitle}` : 'Shop this product';
        productLink.hidden = false;
      } else {
        productLink.removeAttribute('href');
        productLink.textContent = '';
        productLink.hidden = true;
      }

      if (typeof dialog.showModal === 'function') dialog.showModal();
      return;
    }

    const closeButton = event.target.closest('[data-inservice-close]');
    if (closeButton) {
      closeButton.closest('dialog')?.close();
      return;
    }

    if (event.target.matches('[data-inservice-dialog]')) {
      event.target.close();
    }
  });
})();
